module.exports = __webpack_public_path__ + "img/ball_7.27154a48.png";